export const BOOKING_COMMENTS='BOOKING_COMMENTS';
export const BACKPAGE_TO_REDIRECT = 'BACKPAGE_TO_REDIRECT';
export const PNR_HISTORY = 'PNR_HISTORY';
export const MANIFEST_DETAILS = 'MANIFEST_DETAILS';
export const SET_SIDEMENU_FLAG = 'SET_SIDEMENU_FLAG';